import React from 'react';
import { X } from 'lucide-react';
import { useInView } from '../hooks/useInView';
export function OldSolutionsSection() {
  const {
    ref,
    isVisible
  } = useInView();
  const solutions = [{
    title: '"Ámate"',
    desc: 'suena bonito, pero no te dice qué hacer cuando estás en plena escena.'
  }, {
    title: '"Organízate"',
    desc: 'ayuda, pero no cura el juez interno.'
  }, {
    title: '"No te compares"',
    desc: 'falla porque la comparación ya se volvió automática.'
  }, {
    title: '"Algún día haré terapia"',
    desc: 'es válido… pero mientras tanto sigues viviendo con el tribunal abierto.'
  }];
  return <section ref={ref} className="w-full bg-[#F5F1E8] py-10 px-6 md:py-14 border-t border-b border-gold/10" data-id="element-139">
      <div className={`max-w-2xl mx-auto fade-in-section ${isVisible ? 'is-visible' : ''}`} data-id="element-140">
        <h2 className="font-serif text-3xl md:text-4xl text-navy font-bold mb-8 text-center" data-id="element-141">
          Por qué lo que ya intentaste no te sirvió
        </h2>

        <div className="space-y-4 mb-8" data-id="element-142">
          {solutions.map((item, idx) => <div key={idx} className="flex items-start gap-3" data-id="element-143">
              <div className="mt-1 flex-shrink-0 text-red-400" data-id="element-144">
                <X className="w-5 h-5" data-id="element-145" />
              </div>
              <div data-id="element-146">
                <span className="font-serif font-bold text-lg text-text-muted line-through decoration-red-400 decoration-2" data-id="element-147">
                  {item.title}
                </span>
                <span className="font-sans text-lg text-text-dark ml-2" data-id="element-148">
                  — {item.desc}
                </span>
              </div>
            </div>)}
        </div>

        <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-navy" data-id="element-149">
          <p className="font-serif text-xl text-navy leading-relaxed text-center" data-id="element-150">
            "Tú no necesitas más teoría. Necesitas un método corto que puedas
            usar con sueño, con bulla, con poco tiempo."
          </p>
        </div>
      </div>
    </section>;
}